export default "__VITE_ASSET__BH_afMMf__"